/**
 * S2.5: Cegid FAC API Wrapper (Facturación/Recibos)
 * Endpoints: Auth, Customers, Invoices, Concepts, Sets, Incidences
 */

import { cegidFetch } from './auth';
import type { CegidFacCustomer, CegidFacInvoice, CegidFacIncidence } from './types';

/**
 * Get customers from billing system.
 * GET /api/customers/
 */
export async function getCustomers(): Promise<CegidFacCustomer[]> {
  const data = await cegidFetch('fac', '/api/customers/');
  return Array.isArray(data) ? data : [];
}

/**
 * Get invoices from billing system.
 * GET /api/invoices/?ejercicio=X
 */
export async function getInvoices(ejercicio?: string): Promise<CegidFacInvoice[]> {
  const params: Record<string, string> = {};
  if (ejercicio) params.ejercicio = ejercicio;
  const data = await cegidFetch('fac', '/api/invoices/', { params });
  return Array.isArray(data) ? data : [];
}

/**
 * Get concepts.
 * GET /api/concepts/
 */
export async function getConcepts(): Promise<any[]> {
  const data = await cegidFetch('fac', '/api/concepts/');
  return Array.isArray(data) ? data : [];
}

/**
 * Get sets (conjuntos).
 * GET /api/sets/
 */
export async function getSets(): Promise<any[]> {
  const data = await cegidFetch('fac', '/api/sets/');
  return Array.isArray(data) ? data : [];
}

/**
 * Post an incidence.
 * POST /api/Incidences/incidence
 */
export async function postIncidence(incidence: CegidFacIncidence): Promise<any> {
  return cegidFetch('fac', '/api/Incidences/incidence', {
    method: 'POST',
    body: incidence,
  });
}

/**
 * Post a new concept.
 * POST /api/concepts/concept
 */
export async function postConcept(concept: { descripcion: string; [key: string]: any }): Promise<any> {
  return cegidFetch('fac', '/api/concepts/concept', {
    method: 'POST',
    body: concept,
  });
}
